// Change the value of the `variantChangeEvent` variable to the event name that triggers when the variant changes.
// For prestige theme, the event name is `variant:change`
// For other themes, the event name might be different. You can find the event name by inspecting the element that triggers the event when the variant changes.
const variantChangeEvent = 'variant:change';
const klaviyoBisButton = document.getElementById('KlaviyoBisButton');

document.addEventListener(variantChangeEvent, (event) => {
  switch (event.detail.variant.available) {
    case false:
      klaviyoBisButton.hidden = false;
      break;

    default:
      klaviyoBisButton.hidden = true;
      break;
  }
})

class GTCKlaviyoBis extends HTMLElement {

  constructor() {
    super();
    this.handleSubmit.bind(this)
  }

  connectedCallback() {
    this.dom = {
      form: this.querySelector('form'),
      infoText: this.querySelector('[data-info]'),
      successText: this.querySelector('[data-success]'),
      errorText: this.querySelector('[data-errors]')
    };

    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener(variantChangeEvent, this.variantChanged.bind(this));
    this.dom.form.addEventListener('submit', this.handleSubmit);
  }

  variantChanged(event) {
    this.closest('gtc-modal').querySelector('[data-variant-title]').innerText = event.detail.variant.title;
    this.reset();
  }

  reset() {
    this.dom.form.reset();
    this.dom.successText.hidden = true;
    this.dom.errorText.hidden = true;
    this.dom.infoText.hidden = false;
    this.dom.form.hidden = false;
  }

  getVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  newsletterSubscription = (listId) => ({
    "list": {
      "data": { "type": "list", "id": listId }
    }
  });

  payload = (email, variant) => ({
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email,
            },
          },
        },
        channels: ['EMAIL'],
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: `$shopify:::$default:::${ variant }`,
          },
        },
      },
    },
  });

  handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(this.dom.form);
    const email = formData.get('email').toString();
    const variantId = this.getVariantFromUrl() ?? formData.get('variant').toString();
    const apiKey = this.getAttribute('data-api-key');
    
    const bodyObject = this.payload(email, variantId);

    // Subcribe should omly be visible if the klaviyo_list_id is set in theme settings
    const subscribeId = formData.has('subscribeToNewsletter') ? formData.get('subscribeToNewsletter').toString() : null;
    
    if (subscribeId) {
      bodyObject.data.relationships = {
        ...bodyObject.data.relationships,
        ...this.newsletterSubscription(subscribeId)
      }
    }

    fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${ apiKey }`,
      {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          revision: '2024-02-15',
        },
        body: JSON.stringify(this.payload(email, variantId)),
      },
    )
      .then(() => {
        this.dom.successText.hidden = false;
        this.dom.form.hidden = true;
        this.dom.infoText.hidden = true;
      })
      .catch(error => {
        console.warn('error', error)
        this.dom.errorText.hidden = false;
        setTimeout(() => {
          this.reset();
        }, 10000);
      });
  };
}

if (!window.customElements.get("gtc-klaviyo-bis")) {
  customElements.define('gtc-klaviyo-bis', GTCKlaviyoBis);
}
